import { createSlice } from '@reduxjs/toolkit';

export const defaultSession = {
    isLoggedIn: false,
    userId: '',
    username: '',
    accountType: 'visitor',
    remoteId: '',
    loading: true,
    currencyAbrv: 'TRY',
};

export const sessionSlice = createSlice({
    name: 'session',
    initialState: defaultSession,
    reducers: {
        setSession: (state, action) => {
            const { isLoggedIn, userId, accountType, username, remoteId, currencyAbrv } = action.payload;
            state.isLoggedIn = isLoggedIn;
            state.currencyAbrv = currencyAbrv;
            state.userId = userId;
            state.accountType = accountType;
            state.username = username;
            state.remoteId = remoteId;
            state.loading = false;
        },
        destroySession: (state) => {
            const { isLoggedIn, userId, accountType, username, remoteId } = defaultSession;
            state.isLoggedIn = isLoggedIn;
            state.userId = userId;
            state.accountType = accountType;
            state.username = username;
            state.remoteId = remoteId;
            state.loading = false;
            state.currencyAbrv = '';
        },
    },
});

export const { setSession, destroySession } = sessionSlice.actions;
export default sessionSlice.reducer;
